import {Inject, Injectable} from '@angular/core';
import {DOCUMENT} from '@angular/common';

import {ParametersService} from './parameters.service';
import {
    ActionFunc,
    CancelButtonLabel,
    PopupData,
    PopupElement,
    DocumentType,
    GeneralPolicyLanguage,
    RegulationsKoltonLanguage,
    RegulationsLanguage, Language, AlertDialog, ConfirmDialog
} from "../models";
import {AlarmMessage} from "../models/alarms";
import {SubtitlesService} from "./subtitles.service";

@Injectable({
    providedIn: 'root'
})
export class AppAlertService {
    popupElements: (PopupElement | AlarmMessage)[] = [];
    private temporaryPopupArray: any[] = [];
    progressValue = 0;
    progressBarMessage = '';
    windowHeight: number;
    alertDialog: AlertDialog | null = null;
    confirmDialog: ConfirmDialog | null = null;

    constructor(
        @Inject(DOCUMENT) private document: Document,
        private parameters: ParametersService,
        private subtitles: SubtitlesService,
    ) {
        this.windowHeight = window.innerHeight;
    }

    private progress(time: number, callback: () => void): void {
        const interval = time * 10;

        setTimeout(() => {
            if (this.progressValue < 100) {
                this.progressValue += 1;
                this.progress(time, callback);
            } else {
                this.progressValue = 0;
                this.progressBarMessage = '';

                if (callback !== null) {
                    callback();
                }
            }
        }, interval);
    }

    showProgressBar(message: string, time: number, callback?: () => void) {
        this.progressValue = 0;
        this.progressBarMessage = message;
        this.progress(time, callback);
    }

    showAppAlert(
        message: string,
        okButton?: string,
        okFunction?: ActionFunc,
        cancelButton?: CancelButtonLabel,
        cancelFunction?: ActionFunc,
    ): void {
        const execOkFunction = (index: number): void => {
            if (okFunction !== null) {
                okFunction();
            }
            this.closePopup(index);
        }
        const execCancelFunction = (index: number): void => {
            if (cancelFunction !== null) {
                cancelFunction();
            }
            this.closePopup(index);
        }

        const data: PopupData = {
            message,
            okButton,
            okFunction: execOkFunction,
            cancelButton,
            cancelFunction: execCancelFunction,
        };

        this.popupElements.push({
            url: 'old-alert',
            id: null,
            data
        });
    }

    showPopup(popupData: any): void {
        const popupIndex = this.popupElements.findIndex(item => item.id === popupData.id);
        if (popupIndex < 0 && this.parameters.modules.length) {
            const module = this.parameters.modules.find((module) => module.udid === popupData.moduleUdid);
            const template = this.getTemplate(popupData);

            this.popupElements.push({
                url: template,
                id: popupData.id,
                data: popupData,
                module: module,
            });
        }
    }

    showDocumentPopup(language: Language, type: DocumentType): void {
        let url = '';
        let lang = 'en';

        if (this.popupElements.length > 0) {
            this.temporaryPopupArray = this.popupElements;
            this.popupElements = [];
        }

        switch (type) {
            case 'regulations':
                if (window.location.host.includes('kolton')) {
                    lang = this.regulationsKoltonLanguage(language);
                    url = `regulations_kolton_${lang}`
                } else {
                    lang = this.regulationsLanguage(language);
                    url = `regulations_${lang}`;
                }
                break;
            case 'generalPolicy':
                lang = this.generalPolicyLanguage(language);
                url = `general_policy_${lang}`;
                break;
            case 'policy':
                if (window.location.host.includes('kolton')) {
                    lang = this.regulationsKoltonLanguage(language);
                    url = `policy_kolton_${lang}`;
                } else {
                    lang = this.regulationsLanguage(language);
                    url = `policy_${lang}`;
                }
                break;
            case 'regulations_rules_service24':
                url = 'regulations_rules_service24';
                break;
        }

         this.popupElements.push({
            url: url,
            id: null,
            data: {}
        });

    }

    private regulationsLanguage(lang: Language): RegulationsLanguage {
        switch (lang) {
            case 'pl':
                return 'pl';
            case 'de':
                return 'de';
            default:
                return 'en';
        }
    }

    private regulationsKoltonLanguage(lang: Language): RegulationsKoltonLanguage {
        return lang === 'pl' ? 'pl' : 'en';
    }

    private generalPolicyLanguage(lang: Language): GeneralPolicyLanguage {
        return lang === 'pl' ? 'pl' : 'en';
    }

    private getTemplate(data: any): string {
        let templatePath = ''

        switch (data.alarmType) {
            case 'user_information':
                templatePath = 'user-information';
                break;
            case 'alarm':
            case 'warning':
            case 'notification':
                templatePath = 'simple-message';
                break;
            case 'policy':
                templatePath = 'policy';
                break;
        }
        return templatePath;
    }

    closePopup(index: number): void {
        this.popupElements.splice(index, 1);
    }

    closePolicy(): void {
        this.popupElements = this.temporaryPopupArray;
        this.temporaryPopupArray = [];
    }

    origin(): string {
        return window.location.origin;
    }

    scrollTo(id: string): void {
        let el = this.document.getElementById(id);
        el.scrollIntoView({behavior: 'smooth'});
    }

    openAlertDialog(alertDialog: AlertDialog): void {
        this.alertDialog = alertDialog;
    }

    closeAlertDialog(): void {
        if (this.alertDialog.okFunction) {
            this.alertDialog.okFunction();
        }
        this.alertDialog = null;
    }

    openDemoAccountDialog(): void {
        this.alertDialog = {
            title: this.subtitles.setSubtitle(1913),
            message: this.subtitles.setSubtitle(3529),
            okButtonText: this.subtitles.setSubtitle(475),
        };
    }

    openConfirmDialog(confirmDialog: ConfirmDialog): void {
        this.confirmDialog = confirmDialog;
    }

    confirmDialogAction(): void {
        this.confirmDialog.okFunction();
        this.confirmDialog = null;
    }

    closeConfirmDialog(): void {
        if(this.confirmDialog.cancelFunction){
            this.confirmDialog.cancelFunction();
        }
        this.confirmDialog = null;
    }
}
